<template>
  <div class="PageBox">
    <div class="ScrollBox">
      <van-cell
        size="large"
        :title="$t('userInfo.default[1]')"
        center
        is-link
        @click="showHeader = true"
        style="margin-bottom: 20px;"
      >
        <div
          v-if="
            UserInfo.header.indexOf('upload') >= 0 ||
            UserInfo.header.indexOf('aliyuncs') >= 0
          "
        >
          <img class="head" :src="`${UserInfo.header}`"  height="100"
              style="border-radius: 100%">
        </div>
        <div v-else>
          <img :src="`./static/head/${UserInfo.header}`" height="45" />
        </div>
      </van-cell>
      <van-cell
        size="large"
        :title="$t('userInfo.default[2]')"
        center
        :value="UserInfo.phone"
      />
      <van-cell
        size="large"
        :title="$t('userInfo.default[3]')"
        center
        :value="$t('userInfo.default[8]')"
        to="/user/bankCard"
        is-link
      />
      <van-cell
        size="large"
        :title="$t('userInfo.default[5]')"
        center
        :value="$t('userInfo.default[8]')"
        to="/user/set/info"
        is-link
      />
      <van-cell
        size="large"
        :title="$t('userInfo.default[6]')"
        center
        :value="$t('userInfo.default[8]')"
        is-link
        @click="showPassWord = true"
      />
      <van-cell
        size="large"
        :title="$t('userInfo.default[7]')"
        center
        :value="$t('userInfo.default[8]')"
        is-link
        @click="showPayWord = true"
      />
      <van-cell
        class="Cache"
        size="large"
        :title="$t('userInfo.default[13]')"
        center
        is-link
        @click="clearCache"
      />
      
      <van-button block style="margin-top: 30px;color: #fff;background:linear-gradient(to right, #37774C, #37774C);" @click="clearCache">{{ $t("userInfo.default[14]") }}</van-button>
    </div>
    <van-action-sheet
      <!-- v-model="showHeader" -->
      :title="$t('userInfo.default[9]')"
      close-on-popstate
      style="background: white;
          padding-top: 10px;"
    >
      <van-radio-group v-model="radioHeader">
        <van-grid clickable icon-size="45" column-num="4">
          <van-grid-item :icon="`./static/head/head_${item}.png`" v-for="item in 8" :key="item" @click="selectHeader(item)" />
        </van-grid>
      </van-radio-group>
      <!-- <div
        style="
          width: 20.56%;
          margin: 0 auto;
        "
      >
        <van-uploader
          v-model="exampleImg"
          :after-read="afterRead"
          :max-count="1"
        ></van-uploader>
      </div>
      <div style="padding: 16px;background-color:#ffffff;">
        <van-button round type="default" block style="background-color: #FF5656;"
          @click="selectHeader"
          >{{ $t("userInfo.default[12]") }}</van-button
        >
      </div> -->
    </van-action-sheet>
    <van-action-sheet
      v-model="showPassWord"
      :title="$t('userInfo.default[10]')"
      close-on-popstate
    >
      <van-field
        v-model.trim="postData.o_password"
        type="password"
        :label="$t('userInfo.label[0]')"
        :placeholder="$t('userInfo.placeholder[0]')"
        clearable
        size="large"
      />
      <van-field
        v-model.trim="postData.n_password"
        type="password"
        :label="$t('userInfo.label[1]')"
        :placeholder="$t('userInfo.placeholder[1]')"
        clearable
        size="large"
      />
      <van-field
        v-model.trim="postData.r_password"
        type="password"
        :label="$t('userInfo.label[2]')"
        :placeholder="$t('userInfo.placeholder[2]')"
        clearable
        size="large"
      />
      <div style="padding: 16px;background-color:#ffffff;">
        <van-button round type="default" block style="font-size: 16px;background:linear-gradient(to right, #37774C, #37774C);"
          @click="setUserInfo"
          >{{ $t("userInfo.default[12]") }}</van-button
        >
      </div>
    </van-action-sheet>

    <van-action-sheet
      v-model="showPayWord"
      :title="$t('userInfo.default[11]')"
      close-on-popstate
    >
      <van-field
        v-model.trim="postData.o_payword"
        type="password"
        :label="$t('userInfo.label[3]')"
        :placeholder="$t('userInfo.placeholder[3]')"
        clearable
        size="large"
        v-if="UserInfo.is_fund_password == 1"
      />
      <van-field
        v-model.trim="postData.n_payword"
        type="password"
        :label="$t('userInfo.label[4]')"
        :placeholder="$t('userInfo.placeholder[4]')"
        clearable
        size="large"
      />
      <van-field
        v-model.trim="postData.r_payword"
        type="password"
        :label="$t('userInfo.label[5]')"
        :placeholder="$t('userInfo.placeholder[5]')"
        clearable
        size="large"
      />
      <div style="padding: 16px;background-color:#ffffff;">

        <van-button round type="default" block style="font-size: 16px;background:linear-gradient(to right, #37774C, #37774C);"
          @click="setUserInfo">{{ $t("userInfo.default[12]") }}</van-button
        >
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import FacebookPixel from '@/utils/FacebookPixel'
export default {
  name: "Info",
  components: {},
  props: ['type'],
  data() {
    return {
      showHeader: false,
      showPassWord: false,
      showPayWord: false,
      radioHeader: "",
      postData: {},
      exampleImg: [],
    };
  },
  computed: {},
  watch: {
    
  },
  created() {
    this.$parent.navBarTitle = this.$t("userInfo.default[0]");
    this.$Model.GetUserInfo();
    if(this.type=='fpwd') {
        this.showPayWord = true
      }
  },
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
    compressImg(file) {
      this.$Util.CompressImg(file.file.type, file.content, 750, (image) => {
        let param = new FormData();
        param.append("token", localStorage["Token"]);
        param.append("type", 3);
        param.append("image", image, file.file.name);
        this.$Model.UploadImg(param, (data) => {
          if (data.code == 1) {
            file.message = this.$t("upload[2]");
            file.status = "success";
            file.url = data.url;
          } else {
            file.status = "failed";
            file.message = this.$t("upload[3]");
          }
        });
      });
    },
    uploadImgs(file) {
      if (file.length) {
        file.forEach((item) => {
          if (!item.file.type.match(/image/)) {
            item.status = "failed";
            item.message = this.$t("upload[1]");
            return;
          }
          this.compressImg(item);
        });
      } else {
        if (!file.file.type.match(/image/)) {
          file.status = "failed";
          file.message = this.$t("upload[1]");
          return;
        }
        this.compressImg(file);
      }
    },
    selectHeader(item) {
      this.postData.header = 'head_'+item+'.png';//this.exampleImg.flatMap((item) => item.url)[0];
      this.setUserInfo();
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = this.$t("upload[0]");
      this.uploadImgs(file);
    },
    setUserInfo() {
      this.$Model.SetUserInfo(this.postData, (data) => {
        if (data.code == 1) {
          if (this.showHeader) {
            this.showHeader = false;
          }
          if (this.showPassWord) {
            this.showPassWord = false;
          }
          if (this.showPayWord) {
            this.showPayWord = false;
            this.$router.push("/user/withdraw");
          }
          this.postData = {};
        }
      });
    },
    clearCache() {
      FacebookPixel.trackCustomEvent('logout');
      localStorage.clear();
      this.$Model.GetBackData();
      this.$router.push("/login");
    },
  },
};
</script>
<style scoped>
.PageBox{
  background-color: #F4F5F7;;
}
.van-cell__left-icon {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}
.van-icon__image {
  width: 100%;
  height: 100%;
}
.van-cell__title {
  font-size: 14px;
}
.van-action-sheet__header {
  background-color: #fff;
  color: #333;
}
</style>